define('models/SetupModel',[
    'require',
    'backbone',
    'underscore',
    'json!datas/routes.json',
    'ObjectModel',
    'LocalStorage',
    'app',
    'moment',
    'site_vars',
    //
    'ErrorModel',
    'LogExecutionTime',
    'models/SetupPrivateModel',
    'models/UniversalLinkCollection',
    //
    'models/AvisverifieCollection',
    'models/CarrierCollection',
    'models/CategoryCollection',
    'models/ConfigurationCollection',
    'models/CountryCollection',
    'models/CurrencyCollection',
    'models/GenderCollection',
    'models/HybridRoutingCollection',
    'models/InstagramCategoryCollection',
    'models/InstagramPostCollection',
    'models/LanguageCollection',
    'models/MacaronCollection',
    'models/MenuCollection',
    'models/NewsCollection',
    'models/NewsFlagCollection',
    'models/PaymentMethodCollection',
    'models/PaymentModeCollection',
    'models/PaymentGroupCollection',
    'models/PaymentBrandCollection',
    'models/PictureTypeCollection',
    'models/PostcodeCollection',
    'models/ProductCollection',
    'models/StoreCollection',
    'models/StoreServiceCollection',
    'models/TranslationModel',
    'models/WidgetGroupCollection',
    'models/WidgetCollectionCollection',
    'models/WidgetLayoutFormatCollection',
    'models/WidgetInstanceCollection',
    'models/IngredientCollection',
    'models/TagCollection',
    'models/AllergenGroupCollection',
    'models/BannerCollection',
    'models/StoreBenefitCollection',
    //
    'modernizr',

], function (
    require,
    Backbone,
    _,
    routesUrl,
    ObjectModel,
    LocalStorage,
    app,
    moment,
    site_vars,
    //
    ErrorModel,
    LogExecutionTime,
    SetupPrivateModel,
    //
    UniversalLinkCollection,
    // attention, les variables suivantes sont utilisées via eval()
    // donc faire attention aux noms
    AvisverifieCollection,
    CarrierCollection,
    CategoryCollection,
    ConfigurationCollection,
    CurrencyCollection,
    GenderCollection,
    HybridRoutingCollection,
    InstagramCategoryCollection,
    InstagramPostCollection,
    LanguageCollection,
    MacaronCollection,
    MenuCollection,
    NewsCollection,NewsFlagCollection,
    PaymentMethodCollection,
    PaymentModeCollection,
    PaymentGroupCollection,
    PaymentBrandCollection,
    PictureTypeCollection,
    PostcodeCollection,
    ProductCollection,
    StoreCollection,
    StoreServiceCollection,
    TranslationModel,
    WidgetGroupCollection,
    WidgetCollectionCollection,
    WidgetLayoutFormatCollection,
    WidgetInstanceCollection,
    IngredientCollection,
    TagCollection,
    AllergengroupCollection,
    BannerCollection,
    StoreBenefitCollection
)
{
    //
    // Model Setup
    //

    // global app reference
    // warning : this feature is for debug only, please use require.js
    window.app = app;
    //

    var setup,
        objects = {},
        setupPrivate,
        sync;
    var SetupModelPrototype = {

        name: 'SetupModel',
        route: 'apiSetupModel',
        remoteCache: 'no-cache',
        defaults: {
            storeInt:[],
            storeService:[],
            allergengroup:[],
        },

        initialize: function ()
        {

            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this, arguments);
            //

            setup = this;
            LogExecutionTime('start setup...');
            setupPrivate = new SetupPrivateModel();
            //
            setupPrivate.listenTo(app,'ws__update_sync',setupPrivate.updateSync);

            app.setupErrorModel(ErrorModel);

            setup.on('sync', setup.onSetup, setup);
            setup.on('error', setup.onSetupError, setup);
            setupPrivate.on('setupPrivate', setup.allSetupObjectsReady, setup);
            setup.fetch();
        },
        onSetupError:function(a,b,c){
            var statusText = c.textStatus || b.statusText || 'UnknownStatus';
            var statusCode = b.status || 500;
            app.error("JSSetupError", {statusText:statusText,statusCode:statusCode})
            app.alert({
                title: site_vars.default_warning_title || 'Attention',
                subtitle: site_vars.default_warning_setup || 'Une erreur est survenue durant le chargement, veuillez recharger la page.',
                validation:'Recharger',
            },function(){
                window.location.reload(true);
            });
        },
        onSetup: function ()
        {
            // instancie tous les objets issus du JSON en collection Backbone
            _(setup.attributes).each(function (object, key)
            {
                // essaie de fabriquer le constructeur des collections
                var constructorName = key[0].toUpperCase() + key.slice(1);
                switch (key) {
                    // seul la traduction est un Model
                    case 'translation':
                        constructorName = constructorName + 'Model';
                        break;
                    case 'allergengroup':
                        constructorName = 'AllergenGroupCollection';
                        break;
                    case 'storeInt':
                        constructorName = 'StoreCollection';
                        break;
                    default :
                        constructorName = constructorName + 'Collection';
                }
                try {
                    var constructor = require('models/'+constructorName);
                } catch (err) {
                    constructor = Backbone.Collection;
                    //return;
                }
                var o;
                if (typeof(constructor) == 'function') {
                    // si le constructeur existe
                    // on construit la collection
                    o = objects[key] = new constructor(object);
                }
                o.trigger('sync', o);
            });

            if(Modernizr.inapp){
                var universalLinkCollection = new UniversalLinkCollection();
                objects['universalLink'] = universalLinkCollection;
                universalLinkCollection.fetch();
            }

            //
            // charge la variante linguistique (locale) de moment.js
            //
            function LoadMomentLocale(callback) {
                var isoLang = app.isoLang(),
                    momentLocalCode = objects.configuration.getValue('_MOMENT_JS_LOCALE_') || isoLang;
                function MomentCallback(){
                    moment.locale(momentLocalCode);
                    callback();
                }
                switch(momentLocalCode){
                    default:
                        LogExecutionTime('loading moment.js locale');
                        require(['momentLocale/' + momentLocalCode], MomentCallback, MomentCallback);
                        break;
                    case '':
                    case 'en':
                        momentLocalCode = 'en';
                        MomentCallback();
                    break;
                }
            }

            //
            // charge les variables privées (customer, cart, sync)
            //
            function LoadSetupPrivate(){
                LogExecutionTime('LoadSetupPrivate',5);
                setupPrivate.setup();
            }
            //
            LoadMomentLocale(LoadSetupPrivate);

        },
        allSetupObjectsReady:function(privateObjects){
            //
            // surchage les objets privés aux publiques
            //
            if(!privateObjects.sync.onChangeAssetVersion()){
                // stop le chargement ici, si les assets ont changés
                return;
            }else if(privateObjects.sync.test()){
                //
                // cache local est purgé sans distinction, grosse chasse d'eau
                LocalStorage.ls.clear();
                //
                // force un rechargement du setup
                // et redémarre le processus de chargement
                setup.remoteFetch();
                return;
            }
            _(objects).extend(privateObjects);
            app.setupObjects(objects);
            LogExecutionTime('setup private ready');
        }
    };


    var SetupModel = ObjectModel.extend(LocalStorage).extend(SetupModelPrototype);

    return SetupModel;
});

